<template>
  <div>
    <b-form-group label-for="idvoices">
      <b-form-select
        id="idvoices"
        v-model="voice"
        :options="speechOptionsVoices"
      ></b-form-select>
    </b-form-group>
    <b-form-group label-for="idtexto">
      <b-form-textarea id="texto" v-model="texto"></b-form-textarea>
    </b-form-group>
    <b-form-group label-for="idspeek">
      <b-button
        id="idspeek"
        variant="success"
        :disabled="!vspeek"
        @click="speak"
        >Falar</b-button
      >
    </b-form-group>
    <!-- 
    speechVoices: {{ speechVoices }}<br />
    voice: {{ voice }}<br />
    voicesselected: {{ voices[voice] }}<br />
    speaking: {{ speaking }}<br />
    texto: {{ texto }}<br />
    voices: {{ voices }}<br />
  --></div>
</template>

<script>
import speech from "../services/speech";
export default {
  name: "SpeechSynthesis",

  beforeMount() {
    this.voices = speech.getOptionsVoices();
  },

  data() {
    return {
      voices: [],
      voice: 0,
      texto: "teste 1,2,3",
    };
  },

  computed: {
    speechOptionsVoices() {
      return this.voices;
    },
    vspeek() {
      return speech.speaking;
    },
  },

  methods: {
    speak(texto) {
      if (texto !== "") texto = this.texto;

      speech.speak(texto);
    },
    setVoice() {
      this.voice = this.voices.findIndex((v) => v.lang === "pt-BR") || 0;
    },
  },
};
</script>